import { useEffect, useState } from "react";
import axios from 'axios';
import { useNavigate, Link, useParams } from "react-router-dom";
import GoogleMapComponent from "./../../../components/GoogleMapComponent";
import AlertMessage from "../../include/AlertMessage";
var _ = require('lodash');

function AddCouponRedemtion() {
    const { crid } = useParams();
    const [formData, setFormData] = useState({ latitude: '', longitude: '', users: '', coupons: crid });
    const [allUsers, setallUsers] = useState([]);
    const [errors, setErrors] = useState({});
    const [customerrors, setCustomerrors] = useState({});
    const redirectHistory = useNavigate();
    const [loading, setLoading] = useState(true);
    const [alert, setAlert] = useState({ type: "", message: "" });


    const token = sessionStorage.getItem('JWT_TOKEN');

    const fetchAllUsers = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/customers/dropdown`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });
            const userdata = await response.data;            
            if (Array.isArray(userdata.data) && userdata.data.length > 0) {
                setallUsers(userdata.data);
            } else {
                setallUsers([]);
            }
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setLoading(false);
        }

    };

    useEffect(() => {
        document.documentElement.className = "";

        fetchAllUsers();
    }, []);

    const validate = () => {
        const newErrors = {};
        if (!formData.latitude) newErrors.latitude = "Latitude feild is required.";
        if (!formData.longitude) newErrors.longitude = "Longitude feild is required.";
        if (!formData.users) newErrors.users = "User feild is required.";
        return newErrors;
    };

    if (formData.coupons !== crid) {
        const custErrors = {};
        custErrors.coupons = "Invalid Coupon.";
        setCustomerrors(custErrors);
    }

    const handleAdd = async (e) => {
        e.preventDefault();
        const newErrors = validate();
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            setLoading(true);
            try {
                //API URL
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/addcouponredemtion/${crid}`, {
                    "latitude": formData.latitude,
                    "longitude": formData.longitude,
                    "users": formData.users,
                    "coupons": crid
                },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token // Replace with your token
                        }
                    }
                );

                if (response.status === 200 || response.status === 201) {
                    const redirectPath = `/couponredemtions/${crid}`;
                    setAlert({ type: "success", message: "Coupon redemptions added successfully!" });
                    setTimeout(() => redirectHistory(redirectPath), 2500); // thoda delay deke redirect                                          
                }

            } catch (err) {
                const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Failed to add coupon redemptions. Please try again");
                setAlert({ type: "error", message: apierror });
            } finally {
                setLoading(false);
            }

        }
    }


    const handleLocationSelect = ({ lat, lng }) => {
        setFormData((prev) => ({
            ...prev,
            latitude: lat,
            longitude: lng,
        }));
    };

    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
                        <li><Link to="/coupons" className='btn btn-primary'>Coupons</Link></li>
                        <li><Link to={`/couponredemtions/${crid}`} className='btn btn-primary'>Redemptions</Link></li>
                        <li>Add</li>
                    </ul>
                </div>
            </div>
            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                                Add {/* Add booking to {name} */}
                            </p>
                        </header>
                        <div className="card-content">
                            {loading ? (
                                <div className="flex justify-center items-center py-10">
                                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                                </div>

                            ) : (
                                <form onSubmit={handleAdd}>
                                    {alert.message && (
                                        <AlertMessage
                                            type={alert.type}
                                            message={alert.message}
                                            onClose={() => setAlert({ type: "", message: "" })}
                                        />
                                    )}
                                    <input className="input" name="coupons" id="coupons" type="hidden" readOnly value={crid} />
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label">Select User <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <div className="select">
                                                    <select id="users" value={formData.users} onChange={e => setFormData({ ...formData, users: e.target.value })}>
                                                        <option value={''}>---Select---</option>
                                                        {allUsers.map((user, index) => (
                                                            <option key={user.$id} value={user.$id}>{user.email}</option>
                                                        ))}
                                                    </select>
                                                    {errors.users && <p className="help" style={{ color: 'red' }}>{errors.users}</p>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label" htmlFor="latitude">Latitude <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" readOnly id="latitude" type="text" placeholder="Latitude" value={formData.latitude} onChange={e => setFormData({ ...formData, latitude: e.target.value })} />
                                            </div>
                                            {errors.latitude && <p className="help" style={{ color: 'red' }}>{errors.latitude}</p>}
                                        </div>
                                        <div className="field">
                                            <label className="label" htmlFor="longitude">Longitude <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" readOnly id="longitude" type="text" placeholder="Longitude" value={formData.longitude} onChange={e => setFormData({ ...formData, longitude: e.target.value })} />
                                            </div>
                                            {errors.longitude && <p className="help" style={{ color: 'red' }}>{errors.longitude}</p>}
                                        </div>
                                    </div>
                                    <div className="field">
                                        <div className="control">
                                            <GoogleMapComponent onLocationSelect={handleLocationSelect} />
                                        </div>
                                    </div>
                                    <div className="flex justify-center items-center">
                                        <div className="field grouped">
                                            <div className="control">
                                                <button type="submit" className="button green">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AddCouponRedemtion;
